import React, {Component} from "react";
import apiClient from "api/client";
import StatsCard from "../../components/Card/StatsCard.jsx";
import {Row, Col} from "react-bootstrap";
import {userActions} from "../../authentication/_actions";
import connect from "react-redux/es/connect/connect";
import {withNamespaces} from "react-i18next";


class StatsRssView extends Component {

    constructor() {
        super();
        this.state = {
            loading: false,
            activeFeeds: 0,
            disabledFeeds: 0,
            removedFeeds: 0,
            totalFeeds: 0,
            activeViewers: 0,
            rssStatusArray: []
        };
    }


    componentDidMount() {

        const url = process.env.REACT_APP_API_URL+"/Rss/Status";

        let user = JSON.parse(localStorage.getItem('user'));
        let token = ""

        if(user){
            token = user.token
        }
        else{
            this.props.dispatch(userActions.logoutUnauthorized());
        }


        let axiosConfig = {
            headers: {
                'X-Id-Token': token
            }
        };


        apiClient.get(url,axiosConfig)
            .then(res => {
                const rssStatusArray = res.data[0];
                const loading = false;
                const activeFeeds = rssStatusArray.ActiveRssFeeds;
                const disabledFeeds = rssStatusArray.DisabledRssFeeds;
                const removedFeeds = rssStatusArray.DeletedRssFeeds;
                const totalFeeds = rssStatusArray.TotalRssFeeds;
                //console.log(applicationStatusArray);
                this.setState({rssStatusArray, loading ,activeFeeds ,disabledFeeds, removedFeeds,totalFeeds});
            })
            .catch(error => {
            this.setState({loading: false});
            this.props.dispatch(userActions.logoutUnauthorized());
            console.log(error);
        });

    }

    render() {
        return (
            <Row>
                <Col lg={3} sm={6}>
                    <StatsCard
                        bigIcon={<i className="fa fa-check-circle text-success"/>}
                        statsText="Active"
                        statsValue={this.state.activeFeeds}
                    />
                </Col>
                <Col lg={3} sm={6}>
                    <StatsCard
                        bigIcon={<i className="fa fa-ban text-warning"/>}
                        statsText="Disabled"
                        statsValue={this.state.disabledFeeds}
                    />
                </Col>
                <Col lg={3} sm={6}>
                    <StatsCard
                        bigIcon={<i className="fa fa-times-circle text-danger"/>}
                        statsText="Removed"
                        statsValue={this.state.removedFeeds}
                    />
                </Col>
                <Col lg={3} sm={6}>
                    <StatsCard
                        bigIcon={<i className="fa fa-users text-info"/>}
                        statsText="Total"
                        statsValue={this.state.totalFeeds}
                    />
                </Col>
            </Row>
        );
    }
}

function mapStateToProps(state) {

    const {authentication} = state;
    const {user} = authentication;
    return {
        user
    };
}

const connectedStatsRssView = connect(mapStateToProps)(StatsRssView);
const connectedStatsRssViewTrans = withNamespaces('common')(connectedStatsRssView);
export {connectedStatsRssViewTrans as StatsRssView};